import { Link } from "react-router-dom";
import { UserPlus, ArrowRight, HandHeart } from "lucide-react";

export const BannerVolontari = () => (
  <section data-testid="home-banner-volontari" className="relative py-16 sm:py-20 bg-[#C15C3D] text-white overflow-hidden">
    <div className="pointer-events-none absolute -top-24 -right-24 w-80 h-80 rounded-full bg-white/10 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-black/10 blur-3xl" />
    <div className="relative max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-10">
      <div className="w-14 h-14 rounded-2xl bg-white/15 border border-white/30 flex items-center justify-center shrink-0">
        <HandHeart className="w-7 h-7 text-white" />
      </div>
      <div className="flex-1">
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black leading-[1.05] tracking-tight">
          La prossima volta, <span className="italic font-light">vieni anche tu.</span>
        </h2>
        <p className="mt-4 text-base sm:text-lg text-white/90 leading-relaxed max-w-2xl">
          Bastano un po' del tuo tempo e la voglia di dare una mano. Unisciti ai volontari di
          Per Asciano e partecipa alle prossime attività per il nostro territorio.
        </p>
      </div>
      <Link
        to="/partecipa"
        data-testid="banner-volontari-cta"
        className="shrink-0 inline-flex items-center justify-center gap-2 rounded-full bg-white text-[#C15C3D] hover:bg-[#1f2d22] hover:text-white font-bold px-7 py-4 transition-colors shadow-lg"
      >
        <UserPlus className="w-5 h-5" />
        Diventa volontario
        <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  </section>
);
